import { createContext, useContext } from 'react';

export const JobSettingsAccessContext = createContext({
  readOnly: false,
  canEdit: true,
});

export const useJobSettingsAccess = () => useContext(JobSettingsAccessContext);

export default JobSettingsAccessContext;
